<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Visitantes Esporádicos' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <div class="div-top">
    <ion-note slot="start">
      <i class="fas fa-user-clock div-icon"></i>
    </ion-note>

    <ion-label class="color-title">
      {{'Visitantes Esporádicos' | translate}}
    </ion-label>
  </div>

  <div>
    <ion-grid class="grid">
      <ion-row *ngFor="let visitante of visitantes;">
        <ion-col size="2" class="ion-col-img">
          <ion-avatar>
            <img [src]="visitante.foto | image:' '" />
          </ion-avatar>
        </ion-col>

        <ion-col size="8">
          <ion-label>
            <h3>{{visitante.nome}}</h3>
          </ion-label>
        </ion-col>

        <ion-col size="2" class="icon-col">
          <ion-note *ngIf="!readOnly" (click)="detalhes(visitante)">
            <ion-icon class="icon-list" name="ellipsis-vertical"></ion-icon>
          </ion-note>
        </ion-col>

        <ion-item-divider></ion-item-divider>
      </ion-row>

      <ion-list *ngIf="!visitantes.length">
        <sem-registro></sem-registro>
      </ion-list>

      <ion-row
        class="ion-justify-content-center"
        *ngIf="(userProvider.hasConfig(119) || userProvider.hasConfig(120)) && !readOnly"
      >
        <ion-col size="auto">
          <ion-button
            class="btn-default"
            expand="block"
            (click)="addVisitantes()"
          >
            {{ 'Adicionar visitante esporádico' | translate }}

            <i class="fa-regular fa-plus"></i>
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row class="ion-justify-content-center" *ngIf="visitantes.length">
        <ion-col size="7">
          <ion-button class="btn-default" expand="block" (click)="proximo()">
            {{ 'Próximo' | translate }}

            <i class="fa-regular fa-arrow-right"></i>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
